// extracted by mini-css-extract-plugin
export var calendarView = "_k8-0";